import React, { useEffect, useMemo, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Container
} from 'reactstrap';
import ProductService from '../../../Product/services/productService';

import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { toast } from 'react-toastify';
import ReactLoader from 'components/Loader';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { formatCurrency } from 'utils/fuctions/formatCurrency';

const ProductsFieldsInfModal = ({ isOpen, toggle, productId }) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [productFields, setProductFields] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      dataField: 'property',
      text: 'Campo',
      headerStyle: { width: '30%', fontWeight: 'bold' }
    },
    {
      dataField: 'value',
      text: 'Valor'
    }
  ];

  const translateKey = (key) => {
    const translations = {
      name: 'Nome',
      description: 'Descrição',
      code: 'Código',
      basePrice: 'Preço Base',
      externalId: 'ID Externo'
    };
    return translations[key] || key;
  };

  const formatValueByType = (value, type) => {
    if (value === null || value === undefined) {
      return 'Não informado';
    }

    switch (type) {
      case 'DATE':
        try {
          const date = new Date(value);
          return date.toLocaleDateString('pt-BR');
        } catch (error) {
          return String(value);
        }

      case 'CURRENCY':
        try {
          return formatCurrency(value, false) || 'Valor inválido';
        } catch (error) {
          return String(value);
        }

      case 'BOOLEAN':
        return value ? 'Sim' : 'Não';

      case 'TEXT':
      default:
        if (Array.isArray(value)) {
          return value.length > 0 ? value.join(', ') : 'Nenhum';
        }
        return String(value);
    }
  };

  const productDetailsAsArray = useMemo(() => {
    if (!productFields) return [];

    const excludeFields = ['id', 'attachments'];

    return Object.entries(productFields)
      .filter(([key]) => !excludeFields.includes(key))
      .map(([key, value]) => {
        let displayValue;

        if (
          value &&
          typeof value === 'object' &&
          Object.prototype.hasOwnProperty.call(value, 'value') &&
          Object.prototype.hasOwnProperty.call(value, 'type')
        ) {
          displayValue = formatValueByType(value.value, value.type);
        } else {
          if (key === 'basePrice') {
            displayValue = formatCurrency(value, false) || 'Valor inválido';
          } else {
            displayValue = formatValueByType(value, 'TEXT');
          }
        }

        return {
          property: translateKey(key),
          value: displayValue
        };
      });
  }, [productFields]);

  useEffect(() => {
    const fetchProductFields = async () => {
      setLoading(true);
      try {
        const response = await ProductService.getShowProductsFields(productId);
        setProductFields(response.data.data);
      } catch (error) {
        toast.error('Erro ao buscar detalhes do produto');
        console.error('Erro ao buscar detalhes do produto:', error);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen && productId) {
      fetchProductFields();
    }
  }, [isOpen, productId]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Detalhes do Produto</ModalHeader>

      <ModalBody>
        <>
          {loading ? (
            <Container
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: '200px' }}
            >
              <ReactLoader />
            </Container>
          ) : (
            <ToolkitProvider
              keyField="property"
              data={productDetailsAsArray}
              columns={columns}
            >
              {(props) => (
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4={true}
                    bordered={false}
                    wrapperClasses="table-responsive"
                    classes="align-items-center table"
                    style={{ width: '100%' }}
                    noDataIndication="Nenhum produto encontrado"
                  />
                </div>
              )}
            </ToolkitProvider>
          )}
        </>
      </ModalBody>

      <ModalFooter>
        <Button
          style={buttonStyle(systemConfiguration.cancelation_button_color)}
          onClick={toggle}
        >
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ProductsFieldsInfModal;
